module.exports = __webpack_public_path__ + "img/building.5a58edbd.png";